import { useTranslation } from 'react-i18next';
import FormDrawer from '../form-drawer/form-drawer.component';
import ChangeEnvForm from 'components/forms/change-env-form/change-env-form.component';
import { useChangeEnvForm } from 'components/forms/change-env-form/change-env-form.hooks';
import { useCallback, useMemo } from 'react';
import { GetEnvironmentsResult } from 'api/qa-env/qa-env.types';
import { ENV_PRESETS } from 'components/forms/change-env-form/change-env-form.constants';
import { getUrlForDynamicEnv } from 'util/getUrlForDynamicEnv';
import { assign } from 'util/location';

const [CUSTOM_PRESET_OPTION, ...OTHER_PRESET_OPTIONS] = Object.values(
  ENV_PRESETS,
).map(opt => ({
  label: opt.label,
  id: opt.id,
}));

const ChangeEnvDrawer = ({ open, close }) => {
  const { t } = useTranslation();
  const { data: environments = [], form, isFetching } = useChangeEnvForm(open);

  const cancel = useCallback(() => {
    form.reset();
    close();
  }, [close, form]);

  const submit = data => {
    assign(getUrlForDynamicEnv(data));
  };

  const options: GetEnvironmentsResult = useMemo(
    () => [CUSTOM_PRESET_OPTION, ...environments, ...OTHER_PRESET_OPTIONS],
    [environments],
  );

  return (
    <FormDrawer
      title={t('drawer.changeEnvDrawer.title')}
      open={open}
      onClose={close}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      data-testid="ChangeEnvDrawer.FormDrawer"
      isLoading={isFetching}
    >
      <ChangeEnvForm environments={options} />
    </FormDrawer>
  );
};

export default ChangeEnvDrawer;
